import React from "react";

const SvgFilterFemale = props => (
  <svg
    viewBox="0 0 128 128"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    {...props}
  >
    <path
      d="M112.684 87.27c-9.989 7.325-20.717 9.545-32.925 7.029 1.332 1.332 2.59 1.85 3.848 2.442 5.993 2.589 12.356 4.069 18.645 5.771 3.477.888 6.954 1.924 10.21 3.403.444.222.962.296 1.332.74-25.896 25.008-70.584 26.932-99.588-.296 3.034-1.406 6.215-2.367 9.397-3.255 6.585-1.924 13.318-3.256 19.607-5.919 1.479-.592 3.033-1.258 4.735-2.516-5.993.888-11.468.962-16.869-.444-5.402-1.406-10.285-3.773-14.724-7.251 6.881-4.809 9.174-11.986 10.58-19.606 1.332-7.325.962-14.798.518-22.197-.666-10.136.888-19.828 6.511-28.559C39.214 8.474 46.909 4.034 56.379 2.629c7.029-1.036 14.058-1.036 21.013.444 14.353 3.107 22.196 13.021 24.12 26.487.962 7.177.444 14.28.222 21.457-.074 1.849-.074 3.699-.074 5.549 0 9.84 3.625 18.644 7.546 27.375.592 1.48 1.332 2.959 3.478 3.329"
      fill="fill"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgFilterFemale;
